const editFormModalWithTextInputFlags = {
    save: 'SAVE CHANGES',
    cancel: 'DISCARD CHANGES'
};

export default editFormModalWithTextInputFlags;